import { Alert } from '@acpaas-ui/react-components';
import { useSearchParams } from 'react-router-dom';
import { FORM_TYPES, FORM_TYPE_PROP } from '../../../constants/settings.constants';
import FormViewWidget from '../../../containers/forms-engine/FormsEngineView';
import FormsEngineWidget from '../../../containers/forms-engine/FormsEngineWidget';
import { getSubmittedByFromUser } from '../../../lib/form.utils';
import { FORMS_ENGINE_CASETABLE_FORM_VIEW_RESOURCE } from '../../../resources/forms.engine.form.view.resource';
import QuestionnaireAnswers from './QuestionnaireAnswers';
import _ from 'lodash';

const QuestionnaireContent = ({
  data,
  dossierId,
  caseTableId,
  isRepresentative,
  answers,
  user,
  formSchema,
  onAnswered,
  write
}) => {
  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();

  if (!write) {
    return null;
  }

  const getCurrentUserAnswer = () => {
    return answers?.find((a) => a?.submittedBy?.userName === user?.userName);
  };

  const storeFormDataBeforeSubmit = (content, onDone) => {
    setSearchParams({ casetafel: caseTableId });
    localStorage.setItem(`questionnaire_form_${user?.userName}`, JSON.stringify(content));
    localStorage.removeItem('recoverForm');
    onDone();
  };

  if (!data?.formSlug) {
    return (
      <p className="u-text-light">
        {isRepresentative
          ? 'Er is geen formulier geselecteerd'
          : 'Formulier is nog niet geselecteerd voor deze casetafel. Vraag jouw voorzitter om het in te stellen.'}
      </p>
    );
  }

  if (!isRepresentative) {
    const answer = getCurrentUserAnswer(answers, user);
    const prefillData = _.mapValues(answer?.form ?? {}, (val) => val?.value ?? '');
    const formDataStorageString = localStorage.getItem(`questionnaire_form_${user?.userName}`);
    const formData = formDataStorageString ? JSON.parse(formDataStorageString) : null;
    localStorage.removeItem(`questionnaire_form_${user?.userName}`);

    return (
      <>
        {!!answer && (
          <div className="u-padding">
            <Alert type="primary" title="Let op" closable={false}>
              Je hebt al een antwoord gegeven. Indien je dit formulier opnieuw indient worden al jouw eerdere antwoorden
              overschreven.
            </Alert>
          </div>
        )}
        <FormsEngineWidget
          slug={data?.formSlug}
          prefillData={formData || prefillData || {}}
          onAfterSubmit={onAnswered}
          onBeforeSubmit={storeFormDataBeforeSubmit}
          submitExtraData={{
            caseTableId,
            dossierId,
            [FORM_TYPE_PROP]: FORM_TYPES.CASETAFEL,
            submittedBy: getSubmittedByFromUser(user)
          }}
        />
      </>
    );
  }

  if (isRepresentative && answers?.length === 0) {
    return <FormViewWidget formData={{}} resource={FORMS_ENGINE_CASETABLE_FORM_VIEW_RESOURCE} slug={data?.formSlug} />;
  }

  return <QuestionnaireAnswers formSchema={formSchema} answers={answers} />;
};

export default QuestionnaireContent;
